import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { useGlobalSnackbar } from "src/context/SnackbarContext";
import { useModals } from "../../../../../../context/ModalContext";
import { updateJobEvent } from "../actions/update-job-event";

export const useJobEventEditMutation = (jobEventUid: string) => {
  const { showSnackbar } = useGlobalSnackbar();
  const queryClient = useQueryClient();
  const { closeByKey } = useModals();
  const mutation = useMutation({
    mutationFn: async (data: any) => {
      await updateJobEvent(data, jobEventUid);
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["job-events"] }),
        queryClient.invalidateQueries({ queryKey: ["job-events-no-pagination"] }),
        queryClient.invalidateQueries({ queryKey: ["widget-job-events"] }),
      ]);
      showSnackbar("Job event updated successfully", "success");
      setTimeout(() => closeByKey(`Dashboard-EditEvent-${jobEventUid}`), 1500);
    },
    onError: (error) => {
      const message = isAxiosError(error) ? error.response?.data?.message : undefined;
      showSnackbar(message || "Failed to update job event", "error");
    },
  });

  return {
    editJobEvent: mutation.mutate,
    isLoading: mutation.isPending,
  };
};
